import { TodoId } from './todo-id-mapping';

const { LABEL_LAYOUT } = TodoId;
const { BRANDED_TRACKING } = TodoId;
const { PACKAGE_SIZES } = TodoId;
const { PACKING_SLIPS } = TodoId;
const { FULFILLMENT } = TodoId;
const { WAREHOUSE } = TodoId;
const { PICKUP } = TodoId;
const { NEGOTIATED_CARRIER } = TodoId;
const { INTERNATIONAL } = TodoId;
const { INVENTORY_SYNC } = TodoId;
const { AUTO_ROUTING } = TodoId;
const { BUNDLES } = TodoId;
const { API } = TodoId;
const { BRANDED_RETURNS } = TodoId;
const { SHOPIFY_RETURNS } = TodoId;
const { RETURNS_URL } = TodoId;
const { RETURNS_HELP } = TodoId;
const { RATE_SHOPPING } = TodoId;
const { CONNECT } = TodoId;
const { AUTOMATION_MORE_SETUP } = TodoId;
const { SHIPSTATION_INVENTORY } = TodoId;
const { GET_STARTED_WEBINAR } = TodoId;
const { ACCOUNT_OPTIMIZATION_WEBINAR } = TodoId;
const { DEMO_ORDER } = TodoId;
const { UPLOAD_PRODUCTS } = TodoId;
const { ACCOUNT_USERS } = TodoId;
const { REORDERING } = TodoId;
const { LOT_TRACKING } = TodoId;

// Freemium todos
const { FREEMIUM_CONNECT_STORE } = TodoId;
const { FREEMIUM_ADD_SHIP_FROM_ADDRESS } = TodoId;
const { FREEMIUM_ADD_PAYMENT_METHOD } = TodoId;
const { FREEMIUM_CONNECT } = TodoId;
const { FREEMIUM_SHIPSTATION_101 } = TodoId;
const { FREEMIUM_RATE_SHOPPING } = TodoId;
const { FREEMIUM_LABEL_LAYOUT } = TodoId;
const { FREEMIUM_CREATE_RETURN_LABEL } = TodoId;
const { FREEMIUM_IMPORT_PRODUCTS } = TodoId;
const { FREEMIUM_SETUP_RETURNS } = TodoId;
const { IMPORT_PRODUCTS } = TodoId;
const { SETUP_RETURNS } = TodoId;
const { SETUP_INSURANCE } = TodoId;
const { PHONE_NUMBER_CAPTURE } = TodoId;

export const todoCardIds = {
  RATE_SHOPPING,
  CONNECT,
  LABEL_LAYOUT,
  BRANDED_TRACKING,
  PACKAGE_SIZES,
  PACKING_SLIPS,
  FULFILLMENT,
  WAREHOUSE,
  PICKUP,
  NEGOTIATED_CARRIER,
  INTERNATIONAL,
  INVENTORY_SYNC,
  SHIPSTATION_INVENTORY,
  AUTOMATION_MORE_SETUP,
  REORDERING,
  AUTO_ROUTING,
  BUNDLES,
  API,
  BRANDED_RETURNS,
  SHOPIFY_RETURNS,
  RETURNS_URL,
  RETURNS_HELP,
  GET_STARTED_WEBINAR,
  ACCOUNT_OPTIMIZATION_WEBINAR,
  DEMO_ORDER,
  UPLOAD_PRODUCTS,
  ACCOUNT_USERS,
  LOT_TRACKING,
  // Freemium todos
  FREEMIUM_CONNECT_STORE,
  FREEMIUM_ADD_SHIP_FROM_ADDRESS,
  FREEMIUM_ADD_PAYMENT_METHOD,
  FREEMIUM_CONNECT,
  FREEMIUM_SHIPSTATION_101,
  FREEMIUM_RATE_SHOPPING,
  FREEMIUM_LABEL_LAYOUT,
  FREEMIUM_CREATE_RETURN_LABEL,
  FREEMIUM_IMPORT_PRODUCTS,
  FREEMIUM_SETUP_RETURNS,
  IMPORT_PRODUCTS,
  SETUP_RETURNS,
  SETUP_INSURANCE,
  PHONE_NUMBER_CAPTURE,
};

const CONNECTED_SHIP_FROM_PAGE = 'connected_ship_from_page';
const AUTOMATION_PAGE = 'automation_page';
const DISCOUNTED_RATES_STEP = 'discounted_rates_step';
const CARRIERS_PAGE = 'carriers_page';
const ADVANCED_OPTIONS_PAGE = 'advanced_options_page';
const INVENTORY_PAGE = 'inventory_page';
const RETURNS_PAGE = 'returns_page';

export const todoPageIds = {
  CONNECTED_SHIP_FROM_PAGE,
  AUTOMATION_PAGE,
  DISCOUNTED_RATES_STEP,
  CARRIERS_PAGE,
  ADVANCED_OPTIONS_PAGE,
  INVENTORY_PAGE,
  RETURNS_PAGE,
};
